"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var utils_1 = require("../../utils");

var __1 = require("../..");

var Button_1 = tslib_1.__importDefault(require("../Buttons/Button"));

var styles = tslib_1.__importStar(require("./CouponApplyListItem.style"));

function CouponApplyListItem(_ref) {
  var flatAmount = _ref.flatAmount,
      discountRate = _ref.discountRate,
      name = _ref.name,
      conditions = _ref.conditions,
      description = _ref.description,
      isUsable = _ref.isUsable,
      _ref$isPublished = _ref.isPublished,
      isPublished = _ref$isPublished === void 0 ? false : _ref$isPublished,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      onApply = _ref.onApply,
      discountType = _ref.discountType;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isFold = _react_1$useState2[0],
      setFold = _react_1$useState2[1];

  var isRateCoupon = discountType === 'RATE';
  var price = isRateCoupon ? "".concat(discountRate) : "".concat(utils_1.toCurrency(flatAmount || 0));
  var suffix = isRateCoupon ? '% 할인' : '원 할인';
  return jsx_runtime_1.jsxs("div", Object.assign({
    css: [styles.container, isPublished && styles.published]
  }, {
    children: [jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.row
    }, {
      children: [jsx_runtime_1.jsxs("div", Object.assign({
        css: [styles.price, !isUsable && styles.disabledPrice]
      }, {
        children: [jsx_runtime_1.jsx("span", Object.assign({
          className: "mrt-price-text"
        }, {
          children: price
        }), void 0), jsx_runtime_1.jsx("span", Object.assign({
          className: "mrt-price-suffix"
        }, {
          children: suffix
        }), void 0)]
      }), void 0), jsx_runtime_1.jsx(Button_1.default, Object.assign({
        type: "secondary",
        size: "medium",
        disabled: !isUsable,
        onClick: onApply
      }, {
        children: isSelected ? jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.applidedTextContainer
        }, {
          children: [jsx_runtime_1.jsx(__1.Icon, {
            name: "ic_check_md_blue_500",
            alt: "checked"
          }, void 0), "\uC801\uC6A9\uB428"]
        }), void 0) : '적용하기'
      }), void 0)]
    }), void 0), jsx_runtime_1.jsx("p", Object.assign({
      css: [styles.name, !isUsable && styles.disabledPrice]
    }, {
      children: name
    }), void 0), description !== null && jsx_runtime_1.jsxs("div", Object.assign({
      css: [styles.row, styles.descriptionContainer]
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        css: [styles.conditionsContainer, !isUsable && styles.disabledConditions]
      }, {
        children: conditions.map(function (condition, index) {
          return jsx_runtime_1.jsx("p", {
            children: condition
          }, react_id_generator_1.default());
        })
      }), void 0), jsx_runtime_1.jsxs("button", Object.assign({
        type: "button",
        css: styles.moreButton,
        onClick: function onClick() {
          setFold(!isFold);
        }
      }, {
        children: [jsx_runtime_1.jsx("span", Object.assign({
          className: "mrt-text"
        }, {
          children: "\uADF8 \uC678 \uC0AC\uC6A9 \uC870\uAC74"
        }), void 0), jsx_runtime_1.jsx(__1.Icon, {
          name: isFold ? 'ic_arrowup_12x12_gray_500' : 'ic_arrowdown_12x12_gray_500',
          alt: "arrow"
        }, void 0)]
      }), void 0)]
    }), void 0), isFold && description !== null && jsx_runtime_1.jsx("div", Object.assign({
      css: styles.descriptionMoreContainer
    }, {
      children: description.split('\n').map(function (eachDescription, index) {
        return jsx_runtime_1.jsx("p", {
          children: eachDescription
        }, react_id_generator_1.default());
      })
    }), void 0)]
  }), void 0);
}

exports.default = react_1.memo(CouponApplyListItem);